const CHANNEL_PARAMS_STORAGE_KEY = "WEB_FUNNEL_CHANNEL_PARAMS";

// utm 5종 + 광고 클릭 ID. Google은 iOS(ATT)에서 gclid 대신 wbraid/gbraid를 붙이고,
// gad_source/gad_campaignid는 utm 미세팅 캠페인에서도 항상 붙는 자동 파라미터다.
const CHANNEL_PARAM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
  "gclid",
  "wbraid",
  "gbraid",
  "gad_source",
  "gad_campaignid",
] as const;

export type ChannelParamKey = (typeof CHANNEL_PARAM_KEYS)[number];

export type ChannelParams = Partial<Record<ChannelParamKey, string>>;

export interface StoredChannelParams {
  params: ChannelParams;
  capturedAt: number;
}

// 랜딩 URL의 유입 채널 파라미터를 localStorage에 저장한다 (last-click 덮어쓰기).
// 파라미터가 하나도 없으면 기존 저장값을 유지한다 — OAuth 왕복·재진입 시 소실 방지.
export function captureChannelParamsFromUrl(
  search: string = window.location.search
): void {
  try {
    const searchParams = new URLSearchParams(search);
    const params: ChannelParams = {};
    CHANNEL_PARAM_KEYS.forEach((key) => {
      const value = searchParams.get(key);
      if (value) {
        params[key] = value;
      }
    });

    if (Object.keys(params).length === 0) return;

    const stored: StoredChannelParams = { params, capturedAt: Date.now() };
    localStorage.setItem(CHANNEL_PARAMS_STORAGE_KEY, JSON.stringify(stored));
  } catch {}
}

export function getStoredChannelParams(): StoredChannelParams | undefined {
  try {
    const raw = localStorage.getItem(CHANNEL_PARAMS_STORAGE_KEY);
    if (!raw) return undefined;

    const stored = JSON.parse(raw);
    if (
      !stored ||
      typeof stored !== "object" ||
      !stored.params ||
      typeof stored.params !== "object" ||
      typeof stored.capturedAt !== "number"
    ) {
      return undefined;
    }
    return stored as StoredChannelParams;
  } catch {
    return undefined;
  }
}
